module.exports = __webpack_public_path__ + "static/img/图层30.ae896f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层30.png
// module id = jM0w
// module chunks = 0